import $ from "jquery";

/**
 * This is used for Fellowship Applicants -> Participating Fellowships with sub-specialties.
 * eg. /fellowship-applicants/participating-fellowships/emergency-medicine-match-specialities/
 *     /fellowship-applicants/participating-fellowships/obstetrics-gynecology-fellowship-match/
 *     /fellowship-applicants/participating-fellowships/radiology-fellowship-match/
 */

/**
 * Vanilla JS
 * TODO: Only classes
 */
// const subGroups = document
//   .querySelectorAll(".sub-specialty")

//   .forEach((subGroup) => {
//     subGroup.querySelector("select").addEventListener("input", (e) => {
//       const subContent = subGroup.querySelector("." + e.target.value);

//       if (subContent) {
//         subGroup
//           .querySelectorAll(".sub-specialty__content")
//           .forEach((node) => node.classList.remove("is--visible"));

//         subContent.classList.add("is--visible");
//       }
//     });
//   });

/**
 * jQuery
 * TODO: Toggles are too bouncy
 */

$(() => {
  $(".sub-specialty select").on("change", (e) => {
    const container = $(e.target).parents(".sub-specialty");

    container
      .find(".sub-specialty__content")
      .not("." + e.target.value)
      .slideUp()
      .promise()
      .done(() => {
        container.find("." + e.target.value).slideDown();
      });
  });
});
